/** 学校档案里的完整在校学生名册:校验完整才拿来写正文。 */
type Data = Record<string, any>;
const uint = (x: unknown): x is number => typeof x === 'number' && Number.isSafeInteger(x) && x >= 0 && x <= 0xffffffff;

export function completeSchoolRoster(data: Data | null | undefined, day: unknown, id: unknown): Data | null {
  const r = data?.studentRoster;
  if (!r || r.complete !== true || r.start !== 0 || r.limit !== null || r.nextStart !== null ||
      !uint(day) || r.day !== day || !uint(id) || r.school?.id !== id || typeof r.enabled !== 'boolean' ||
      !(r.sampleDay === null || uint(r.sampleDay) && r.sampleDay <= day) || !Array.isArray(r.students) ||
      !uint(r.total) || r.total !== r.students.length || !uint(r.present) || !uint(r.absent) || r.present + r.absent !== r.total) return null;
  let previous = -1, present = 0;
  for (const row of r.students) {
    if (!row || row.who?.kind !== 'person' || !uint(row.who.id) || row.who.id <= previous || typeof row.present !== 'boolean') return null;
    previous = row.who.id;
    present += Number(row.present);
  }
  return present === r.present ? r : null;
}

/** 学校档案附没附在校学生名册,写进资料范围一行。 */
export function schoolExportScope(data: Data | null | undefined, day: unknown, id: unknown): string {
  const r = completeSchoolRoster(data, day, id);
  if (r) return `学校档案附在校学生名册 ${r.total} 人。`;
  return data?.studentRoster != null ? '学校档案附的学生名册不完整，见附录。' : '学校档案没有附学生名册。';
}
